<template>
  <message-template :direction="direction" :time="time" :channel="channel">
    <div class="log-audio-block">
      <div class="audio-wrapper">
        <audio style="height: 55px;" controls v-html="audioSrc"></audio>
      </div>
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from './MessageTemplate.vue';

export default {
  name: 'buttonTemplate',
  components: {
    'message-template': MessageTemplate,
  },
  props: {
    data: {
      type: Object,
    },
    direction: {
      type: String,
      default: '',
    },
    audioUrlField: {
      type: String,
      default: 'url',
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
    },
  },
  computed: {
    audioSrc() {
      if (this.data && this.data[this.audioUrlField]) {
        return `<source src="${this.data[this.audioUrlField]}">`;
      } if (this.data
        && this.data.answers
        && this.data.answers[0]
        && this.data.answers[0][this.audioUrlField]) {
        return `<source src="${this.data.answers[0][this.audioUrlField]}">`;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.log-audio-block {
  overflow: hidden;
  background-color: #efefef;
  border-radius: 10px 10px 10px 10px;
  .audio-wrapper {
    height: 55px;
    width: 100%;
  }
}
</style>
